export default __webpack_public_path__ + "static/media/FH010019.d3718f04.jpg";